import { api } from '../lib/api';

export interface AtivoConsumo {
  id: number;
  nome: string;
  unidade_id: number;
  piso_id: number;
  local_id: number;
  patrimonio?: string | null;
  marca?: string | null;
  foto_url?: string | null;
  total_medidores: number;
  medidores_ativos: number;
  ultima_leitura?: string | null;
}

interface AtivoBase {
  id: number;
  nome: string;
  unidade_id: number;
  piso_id: number;
  local_id: number;
  patrimonio?: string | null;
  marca?: string | null;
  foto_url?: string | null;
}

interface MedidorResumo {
  id: number;
  status: string;
  ultima_leitura?: {
    data_leitura: string;
  } | null;
}

let cacheAtivosConsumo: AtivoConsumo[] | null = null;

function dataMaisRecente(atual?: string | null, proxima?: string | null): string | null {
  if (!atual) return proxima || null;
  if (!proxima) return atual;
  return new Date(proxima).getTime() > new Date(atual).getTime() ? proxima : atual;
}

export async function carregarAtivosComConsumo(force = false): Promise<AtivoConsumo[]> {
  if (!force && cacheAtivosConsumo) return cacheAtivosConsumo;

  const ativos = await api<AtivoBase[]>('/ativos/ativos.php');
  const resultados: AtivoConsumo[] = [];

  for (const ativo of ativos) {
    const medidores = await api<MedidorResumo[]>(`/consumo/medidores.php?ativo_id=${ativo.id}`);
    if (!medidores.length) continue;

    const ultimaLeitura = medidores.reduce<string | null>(
      (acumulado, medidor) => dataMaisRecente(acumulado, medidor.ultima_leitura?.data_leitura || null),
      null,
    );

    resultados.push({
      ...ativo,
      total_medidores: medidores.length,
      medidores_ativos: medidores.filter((medidor) => medidor.status === 'ativo').length,
      ultima_leitura: ultimaLeitura,
    });
  }

  resultados.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
  cacheAtivosConsumo = resultados;

  return cacheAtivosConsumo;
}
